import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "skip-link",
  href: "#workspace-content"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["inert"];
const _hoisted_4 = {
  class: "brand-symbol"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  class: "brand-name"
};
const _hoisted_7 = {
  class: "workspace-label"
};
const _hoisted_8 = ["aria-label"];
const _hoisted_9 = {
  key: 0,
  class: "nav-active-dot"
};
const _hoisted_10 = {
  class: "sidebar-bottom"
};
const _hoisted_11 = {
  class: "sidebar-note"
};
const _hoisted_12 = {
  class: "note-icon"
};
const _hoisted_13 = {
  class: "workspace-nav-link",
  href: "https://cfbed.sanyue.de",
  target: "_blank",
  rel: "noopener noreferrer"
};
const _hoisted_14 = {
  class: "sidebar-account"
};
const _hoisted_15 = {
  class: "avatar"
};
const _hoisted_16 = {
  class: "workspace-body"
};
const _hoisted_17 = {
  class: "workspace-topbar"
};
const _hoisted_18 = {
  class: "workspace-location"
};
const _hoisted_19 = ["aria-label", "aria-expanded"];
const _hoisted_20 = {
  class: "topbar-actions"
};
const _hoisted_21 = ["aria-label"];
const _hoisted_22 = {
  id: "workspace-content",
  class: "workspace-content",
  tabindex: "-1"
};
const _hoisted_23 = {
  key: 0,
  class: "workspace-page-heading"
};
const _hoisted_24 = {
  class: "page-eyebrow"
};
const _hoisted_25 = {
  key: 0,
  class: "standalone-theme"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UiIcon = _resolveComponent("UiIcon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_ThemeControl = _resolveComponent("ThemeControl");
  return $options.enabled ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["workspace", 'workspace--' + _ctx.$route.name])
  }, [_createElementVNode("a", _hoisted_1, _toDisplayString(_ctx.$t('modern.skip')), 1), _ctx.menuOpen ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "nav-scrim",
    "aria-label": _ctx.$t('modern.closeMenu'),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closeMenu && $options.closeMenu(...args))
  }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("aside", {
    id: "workspace-navigation",
    class: _normalizeClass(["workspace-sidebar", {
      'is-open': _ctx.menuOpen
    }]),
    inert: _ctx.isMobile && !_ctx.menuOpen
  }, [(_openBlock(), _createBlock(_resolveDynamicComponent($options.customBrandLink ? 'a' : 'router-link'), {
    to: $options.customBrandLink ? undefined : '/',
    href: $options.customBrandLink || undefined,
    target: $options.customBrandLink ? '_blank' : undefined,
    rel: "noopener noreferrer",
    class: "workspace-brand",
    onClick: $options.closeMenu
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_ctx.$store.getters.userConfig?.logoUrl ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: _ctx.$store.getters.userConfig.logoUrl,
      alt: $options.siteName
    }, null, 8, _hoisted_5)) : (_openBlock(), _createBlock(_component_UiIcon, {
      key: 1,
      name: "image"
    }))]), _createElementVNode("span", _hoisted_6, [_createTextVNode(_toDisplayString($options.siteName), 1), _cache[3] || (_cache[3] = _createElementVNode("small", null, "IMAGE WORKSPACE", -1))])]),
    _: 1
  }, 8, ["to", "href", "target", "onClick"])), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('modern.workspace')), 1), _createElementVNode("nav", {
    "aria-label": _ctx.$t('modern.navigation')
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visibleNav, item => {
    return _openBlock(), _createBlock(_component_router_link, {
      key: item.path,
      to: item.path,
      class: _normalizeClass(["workspace-nav-link", {
        'is-active': _ctx.$route.name === item.name
      }]),
      "aria-current": _ctx.$route.name === item.name ? 'page' : undefined,
      onClick: $options.closeMenu
    }, {
      default: _withCtx(() => [_createVNode(_component_UiIcon, {
        name: item.icon
      }, null, 8, ["name"]), _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.label)), 1), _ctx.$route.name === item.name ? (_openBlock(), _createElementBlock("span", _hoisted_9)) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["to", "class", "aria-current", "onClick"]);
  }), 128))], 8, _hoisted_8), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, [_createVNode(_component_UiIcon, {
    name: "spark"
  })]), _createElementVNode("strong", null, _toDisplayString(_ctx.$t('modern.spaceTitle')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('modern.spaceDescription')), 1)]), _createElementVNode("a", _hoisted_13, [_createVNode(_component_UiIcon, {
    name: "book"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('upload.viewDocs')), 1), _createVNode(_component_UiIcon, {
    name: "arrow"
  })]), !_ctx.$store.getters.adminLoggedIn ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    class: "workspace-nav-link workspace-admin-entry",
    to: "/adminLogin",
    onClick: $options.closeMenu
  }, {
    default: _withCtx(() => [_createVNode(_component_UiIcon, {
      name: "settings"
    }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('login.adminTitle')), 1), _createVNode(_component_UiIcon, {
      name: "arrow"
    })]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString($options.ownerInitial), 1), _createElementVNode("span", null, [_createTextVNode(_toDisplayString($options.ownerName), 1), _createElementVNode("small", null, _toDisplayString(_ctx.$t('modern.personalSpace')), 1)]), _cache[4] || (_cache[4] = _createElementVNode("span", {
    class: "account-dot"
  }, null, -1))])])], 10, _hoisted_3), _createElementVNode("div", _hoisted_16, [_createElementVNode("header", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
    ref: "menuButton",
    class: "ui-icon-button mobile-nav-button",
    "aria-label": _ctx.$t('modern.navigation'),
    "aria-expanded": _ctx.menuOpen,
    "aria-controls": "workspace-navigation",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.menuOpen = !_ctx.menuOpen)
  }, [_createVNode(_component_UiIcon, {
    name: _ctx.menuOpen ? 'close' : 'menu'
  }, null, 8, ["name"])], 8, _hoisted_19), _createElementVNode("span", null, _toDisplayString(_ctx.$t('modern.workspace')), 1), _createVNode(_component_UiIcon, {
    name: "chevron"
  }), _createElementVNode("strong", null, _toDisplayString(_ctx.$t($options.currentLabel)), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("button", {
    class: "ui-icon-button language-button",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.changeLanguage && $options.changeLanguage(...args)),
    "aria-label": _ctx.$t('modern.language')
  }, [_createVNode(_component_UiIcon, {
    name: "globe"
  })], 8, _hoisted_21), _createVNode(_component_ThemeControl)])]), _createElementVNode("main", _hoisted_22, [_ctx.$route.name !== 'home' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_24, _toDisplayString($options.pageEyebrow), 1), _createElementVNode("h1", null, _toDisplayString(_ctx.$t($options.currentLabel)), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('modern.' + _ctx.$route.name + 'Description')), 1)]), _ctx.$route.name === 'dashboard' ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    to: "/",
    class: "ui-primary-button"
  }, {
    default: _withCtx(() => [_createVNode(_component_UiIcon, {
      name: "upload"
    }), _createTextVNode(_toDisplayString(_ctx.$t('dashboardTabs.fileUpload')), 1)]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")])])], 2)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [['notFound', 'blockimg', 'whiteliston'].includes(_ctx.$route.name) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_ThemeControl)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")], 64));
}